import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaSearch } from "react-icons/fa";
import {BsFillBellFill } from "react-icons/bs";
import User from './../Images/user.png';


function AdminHeader() {
  return (
    <>
   
<div className='py-3 px-4 d-flex justify-content-between align-items-center dashboard-header'>
                    
                    <form action="">
                                <div className="search-blog">
                                <button><FaSearch /></button>
                                    <input placeholder='Quick Search' type="text" />
                                    
                                </div>
                            </form>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <FaBars/>
                    </button>
                            </div>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav  ms-auto  mb-2 mb-lg-0">
                        <li className="nav-item dropdown">
                        <Link className="nav-link dropdown-toggle second-text fw-bold" to="#" id="navbarDropdown1"
                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <BsFillBellFill/>
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown1">
                                    <li><Link className="dropdown-item" to="#">Profile</Link></li>
                                    <li><Link className="dropdown-item" to="#">Settings</Link></li>
                                    <li><Link className="dropdown-item" to="admin_logout.php">Logout</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link dropdown-toggle second-text fw-bold" to="#" id="navbarDropdown"
                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span className="user-img ">
    <img src={User} alt=""/>
</span>
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><Link className="dropdown-item" to="#">Profile</Link></li>
                                    <li><Link className="dropdown-item" to="#">Settings</Link></li>
                                    <li><Link className="dropdown-item" to="admin_logout.php">Logout</Link></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
             
    </>
  )
}

export default AdminHeader